//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientInvoiceMarkApi, clientMarkApi, clientRemindMarkApi } from '@/api/enterprise';
export default {
  name: 'MarkDialog',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      rules: {
        remarks: ''
      },
      rule: {
        remarks: [{
          required: true,
          message: this.$t('customer.placeholder18'),
          trigger: 'blur'
        }]
      },
      dialogVisible: false,
      loading: false
    };
  },
  watch: {
    config: {
      handler: function handler(nVal) {
        this.rules.remarks = nVal.mark;
      },
      deep: true
    }
  },
  methods: {
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.remarks = '';
    },
    handleConfirm: function handleConfirm() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this.config.type === 1) {
            _this.clientMark(_this.config.id, {
              mark: _this.rules.remarks
            });
          } else if (_this.config.type === 2) {
            _this.invoiceMark(_this.config.id, {
              mark: _this.rules.remarks
            });
          } else if (_this.config.type === 3) {
            _this.clientRemindMark(_this.config.id, {
              mark: _this.rules.remarks
            });
          }
        }
      });
    },
    // 合同列表--付款记录--填写备注
    clientMark: function clientMark(id, data) {
      var _this2 = this;
      this.loading = true;
      clientMarkApi(id, data).then(function (res) {
        _this2.$emit('isMark');
        _this2.handleClose();
        _this2.loading = false;
      }).catch(function (error) {
        _this2.loading = false;
      });
    },
    // 付款提醒
    clientRemindMark: function clientRemindMark(id, data) {
      var _this3 = this;
      this.loading = true;
      clientRemindMarkApi(id, data).then(function (res) {
        _this3.$emit('isMark');
        _this3.handleClose();
        _this3.loading = false;
      }).catch(function (error) {
        _this3.loading = false;
      });
    },
    // 发票申请列表填写备注
    invoiceMark: function invoiceMark(id, data) {
      var _this4 = this;
      this.loading = true;
      clientInvoiceMarkApi(id, data).then(function (res) {
        _this4.$emit('isMark');
        _this4.handleClose();
        _this4.loading = false;
      }).catch(function (error) {
        _this4.loading = false;
      });
    }
  }
};